import React from "react";
import { Link, Navigate, useLocation } from "react-router-dom";
import { buildMyPropertiesSavedRedirectPath } from "../utils/clientMyPropertiesTabs";
import { SAVED_WORKSPACE_TITLE } from "../utils/clientRESavedWorkspace";

/**
 * CL-373A / CL-397C: Legacy /client-portal/real-estate/saved → Search saved workspace.
 */
export default function ClientRESavedLegacyRedirect() {
  const { search } = useLocation();
  const target = buildMyPropertiesSavedRedirectPath(search);

  return (
    <div className="mx-auto max-w-lg px-4 py-10 space-y-4">
      <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">Redirecting…</p>
      <h1 className="text-lg font-semibold text-slate-900">{SAVED_WORKSPACE_TITLE} moved</h1>
      <p className="text-sm text-slate-600">
        Your candidate shortlist, compare tray, and collections now live under{" "}
        <span className="font-medium text-slate-800">Real Estate → Search → Saved properties</span>.
      </p>
      <Link to={target} className="inline-block text-sm font-medium text-slate-900 underline">
        Continue to saved properties
      </Link>
      <Navigate to={target} replace />
    </div>
  );
}
